import React from 'react';
import DocumentTemplate from './utils/DocumentTemplate';
import app from './firebase.js';
import './diploma.css';

const Diploma = () => {
    return (
        <DocumentTemplate
            documentType="diploma"
            app={app}
            customStyles={{
                container: {
                    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                }
            }}
        />
    );
};

export default Diploma;
